module.exports = __webpack_public_path__ + "static/media/file-black.d6e51dbe.svg";